import { render } from "./StepImportanceTable.vue?vue&type=template&id=212813cc&scoped=true"
import script from "./StepImportanceTable.vue?vue&type=script&lang=js"
export * from "./StepImportanceTable.vue?vue&type=script&lang=js"

import "./StepImportanceTable.vue?vue&type=style&index=0&id=212813cc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212813cc"]])

export default __exports__